import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * アイコン
 *【アイコン:icon:string】
 *【代替アイコン:alternateIcon:string】
 *【サイズ:size:number】
 *【色:color:string】
 *【表示条件:visible:boolean】
 *【非活性:disabled:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-icon-button',
  templateUrl: './icon-button.html',
  styles: [`
    .text-title-value {
      font-size: 20px;
      color: #1b1b1b;
    }
  `]
})
export class IconButton extends BaseWidget {
  /**
   * アイコン
   */
  @Input() icon:string

  /**
   * 代替アイコン
   */
  @Input() alternateIcon:string

  /**
   * サイズ
   */
  @Input() size:number

  /**
   * 色
   */
  @Input() color:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/icon-button/icon-button.component.ts